// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__1bnY7","content":"LayoutSettings_content__3xWLj"};